"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CNTable = require("./CNTable");

var _CNTable2 = _interopRequireDefault(_CNTable);

var _stickyFn = require("./sticky-fn");

var StickyFn = _interopRequireWildcard(_stickyFn);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_CNTable2.default.StickyFn = StickyFn;
exports.default = _CNTable2.default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table@0.0.78@@alicd/crui-table/lib/index.js
// module id = 276
// module chunks = 0